module.exports = __webpack_public_path__ + "img/JobSubmissionW4WithholdingsTooltip.79bc93b4.png";